var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-coins-count"},[_c('div',{staticClass:"c-coins-count__icon",domProps:{"innerHTML":_vm._s(_vm.coinsIcon)}}),_c('div',{staticClass:"c-coins-count__sum"},[_vm._v(_vm._s(_vm.coins))])])}
var staticRenderFns = []

export { render, staticRenderFns }